module.exports = __webpack_public_path__ + "static/3-a570d1ba1f399c69d30c72451a680c52.png";